import { Mutations, Actions, Module, Getters } from 'vuex-smart-module'

import { certificateList } from '@/store/modules/certificate/history'

export class CertificateState {}

export class CertificateGetters extends Getters<CertificateState> {}

export class CertificateMutations extends Mutations<CertificateState> {}

export class CertificateActions extends Actions<CertificateState, CertificateGetters, CertificateMutations> {}

export const certificate = new Module({
  state: CertificateState,
  getters: CertificateGetters,
  mutations: CertificateMutations,
  actions: CertificateActions,
  modules: {
    certificateList,
  },
})
